import React from 'react';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import styled from '@emotion/styled';
import { McBookieMainLogoWrapper, McBookieMainLogo } from 'src/domains/common/universes/mcbookie/mcbookie.style';
import { StarSportsMainLogoWrapper, StarSportsMainLogo } from 'src/domains/common/universes/star/star.style';
import { observer } from 'src/utils/mobx-react';

export const SwitchIconWrapper = styled(ChevronDownIcon, { label: 'SwitchIconWrapper' })`
    bottom: 0;
    height: 48px;
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 48px;
    padding: 19px;
    cursor: pointer; 
`;

const ArrowRightIcon = styled(SwitchIconWrapper, { label: 'ArrowRightIcon' })`
    transform: rotate(-90deg);
`;

export const UniverseSwitcherAvailable = styled('div', { label: 'UniverseSwitcherAvailable' })`
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
    left: 0;
    position: absolute;
    top: 100%;
    z-index: 2;
    width: 200px;
`;

export const UniverseSwitcherItem = styled('a', { label: 'UniverseSwitcherItem' })`
    display: flex;
    position: relative;
    text-decoration: none;
`;

export const McBookieSwitch = observer('McBookieSwitch', () => {
    return (
        <McBookieMainLogoWrapper>
            <McBookieMainLogo />
            <ArrowRightIcon/>
        </McBookieMainLogoWrapper>
    );
});

export const StarSportsSwitch = observer('StarSportsSwitch', () => {
    return (
        <StarSportsMainLogoWrapper>
            <StarSportsMainLogo />
            <ArrowRightIcon/>
        </StarSportsMainLogoWrapper>
    );
});
